// PileList.tsx
import React from 'react'
import { ClientSideTable } from 'Presentation/Components/Table'
import { KTSVG } from '../../../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'

interface ShippingOrderListProps {
  SHIPPING_ORDER_LIST_CONFIGS: any
  shippingorders: any
  shippingRequestId: number
  viewOnly: any
}

const ShippingOrderList: React.FC<ShippingOrderListProps> = ({
  SHIPPING_ORDER_LIST_CONFIGS,
  shippingorders,
  shippingRequestId,
  viewOnly,
}) => {
  const roleId = useAuthStore(state => state.profile?.roleId ?? 0, shallow)

  return (
    <section>
      <div className='fs-4 fw-bold d-flex justify-content-between flex-row align-items-center'>
        <div>
          ใบขนส่ง <span className='required' />
        </div>
        {![21].includes(roleId) && !viewOnly && (
          <Link to={`/shipping-request/${shippingRequestId}/shipping-order/create`}>
            <button type='button' className='btn btn-sm btn-primary fw-bolder'>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/files/fil005.svg' />
              สร้างใบขนส่ง
            </button>
          </Link>
        )}
      </div>

      <hr />

      <ClientSideTable
        isGrey
        data={shippingorders}
        columns={SHIPPING_ORDER_LIST_CONFIGS}
        items_per_page={10}
      />
    </section>
  )
}

export default ShippingOrderList
